/*
 ------------------------------------------------------------------
|  Copyright (c) 2015 Izenda, Inc.                                 |
|  ALL RIGHTS RESERVED                                             |
|                                                                  |
|  The entire contents of this file is protected by U.S. and       |
|  International Copyright Laws. Unauthorized reproduction,        |
|  reverse-engineering, and distribution of all or any portion of  |
|  the code contained in this file is strictly prohibited and may  |
|  result in severe civil and criminal penalties and will be       |
|  prosecuted to the maximum extent possible under the law.        |
|                                                                  |
|  RESTRICTIONS                                                    |
|                                                                  |
|  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES           |
|  ARE CONFIDENTIAL AND PROPRIETARY TRADE                          |
|  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS              |
|  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET    |
|  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.                 |
|                                                                  |
|  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED      |
|  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE        |
|  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE       |
|  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT  |
|  AND PERMISSION FROM IZENDA INC.                                 |
|                                                                  |
|  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  |
|  ADDITIONAL RESTRICTIONS.                                        |
 ------------------------------------------------------------------
*/

import localizer from 'share/localization/Izenda.Localizer';

export default {
  get RULES_LIST_TABLE_DEF(){
    return {
      name: {
        key: 'name',
        align: 'center',
        width: 100,
        get title() {
          return localizer.getText('SECURITY_RULES_LIST_TABLE_COLUMN_NAME');
        }
      },
      description: {
        key: 'description',
        align: 'center',
        width: 300,
        minWidth: 100,
        get title() {
          return localizer.getText('SECURITY_RULES_LIST_TABLE_COLUMN_DESCRIPTION');
        }
      },
      action: {
        width: 40,
        align: 'center',
        get title() {
          return '';
        }
      }
    }
  },
  get RULES_TABLE_DEF(){
    return {
      userGroup: {
        key: 'userGroup',
        align: 'center',
        width: 100,
        minWidth: 100,
        get title() {
          return localizer.getText('SECURITY_RULES_SET_TABEL_COLUMN_USER_GROUP');
        }
      },
      userValues: {
        key: 'userValues',
        align: 'center',
        width: 160,
        get title() {
          return localizer.getText('SECURITY_RULES_SET_TABEL_COLUMN_USER_VALUES');
        }
      },
      accessibleValues: {
        key: 'accessibleValues',
        align: 'center',
        width: 160,
        get title() {
          return localizer.getText('SECURITY_RULES_SET_TABEL_COLUMN_ACCESSIBLE_VALUES');
        }
      },
      accessMode: {
        key: 'accessMode',
        align: 'center',
        width: 80,
        get title() {
          return localizer.getText('SECURITY_RULES_SET_TABEL_COLUMN_ACCESS_MODE');
        }
      },
      action: {
        key: 'action',
        align: 'center',
        width: 50,
        get title() {
          return '';
        }
      }
    }
  },
  get ASSIGNED_TYPE() {
    return [
      { value: 1, label: localizer.getText('ACCESS_CONSTANT_LABEL_ASSIGNED_TYPE_EVERYONE') },
      { value: 2, label: localizer.getText('COMMON_LABEL_ROLE') },
      { value: 3, label: localizer.getText('ACCESS_CONSTANT_LABEL_ASSIGNED_TYPE_USER') }
    ];
  },
  get ACCESSIBLE_VALUE_OPTIONS() {
    return [
      { value: '{all}', label: '[All]'},
      { value: '{tenantId}', label: '[Tenant ID]' },
      { value: '{tenantName}', label: '[Tenant Name]' },
      { value: '{roleName}', label: '[Role Name]' },
      { value: '{userName}', label: '[User ID]' }
    ];
  },
  get ACCESS_MODE_OPTIONS() {
    return [
      { value: 1, label: 'Block' },
      { value: 2, label: 'Allow' }
    ];
  },
  get STATE() {
    return {
      none: 0,
      inserted: 1,
      deleted: 2,
      updated: 3
    };
  },
  COMPONENT_CONFIG: {
    1: null,
    2: {
      component: require('modules/User/Izenda.RoleLookUp'),
      props: {
        usingPopup: true,
        valueField: 'id',
        textField: 'name'
      }
    },
    3: {
      component: require('modules/User/Izenda.UserLookUp'),
      props: {
        useSearchName: true,
        usingPopup: true,
        valueField: 'id',
        textField: 'name',
        userModeType: 0,
        useEmailInOptions: true
      }
    }
  },
  get CONSTRAINTS() {
    return {
      REQUIRED: {
        presence: {
          presence: true,
          message: localizer.getText('COMMON_CONSTRAINT_REQUIRED')
        }
      }
    };
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.SecurityRulesConstants.js